import { consultationDefaults } from '../assets/consultationOptions';

const DRAFT_KEY = 'vappytech_consultation_draft_v1';

export function loadConsultationDraft() {
  if (typeof window === 'undefined') {
    return { ...consultationDefaults };
  }

  try {
    const raw = window.localStorage.getItem(DRAFT_KEY);
    if (!raw) {
      return { ...consultationDefaults };
    }

    const parsed = JSON.parse(raw);
    return { ...consultationDefaults, ...parsed };
  } catch {
    return { ...consultationDefaults };
  }
}

export function saveConsultationDraft(values) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(DRAFT_KEY, JSON.stringify(values));
  } catch {
    // Ignore quota / private mode failures.
  }
}

export function clearConsultationDraft() {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.removeItem(DRAFT_KEY);
  } catch {
    // Ignore storage failures.
  }
}
